import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { BuildingStatus } from '../land/state'
import { initialCastle2State, Castle2State } from './state'

export const castle2Slice = createSlice({
  name: 'castle2',
  initialState: initialCastle2State as Castle2State,
  reducers: {
    setCastle2Loading: (state: Castle2State, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setCastle2ImmediateLoading: (state: Castle2State, action: PayloadAction<boolean>) => {
      state.isImmediate = action.payload
    },
    setCastle2Error: (state: Castle2State, action: PayloadAction<string | undefined>) => {
      state.error = action.payload
    },
    setCastle2BuildingStatus: (state: Castle2State, action: PayloadAction<Partial<BuildingStatus>>) => {
      const existingStatus = state.buildingStatus || initialCastle2State.buildingStatus
      const payload = action.payload
      
      const mergedStatus = { ...existingStatus } as Partial<BuildingStatus>
      
      for (const key in payload) {
        if (payload[key as keyof BuildingStatus]) {
          const existingBuilding = existingStatus[key as keyof BuildingStatus]
          const payloadBuilding = payload[key as keyof BuildingStatus]
          if (existingBuilding) {
            mergedStatus[key as keyof BuildingStatus] = {
              ...existingBuilding,
              ...payloadBuilding,
              hp: Number(payloadBuilding?.hp ?? 0),
              maxHp: Number(payloadBuilding?.maxHp ?? 0),
            } as any
          } else {
            mergedStatus[key as keyof BuildingStatus] = {
              ...payloadBuilding,
              hp: Number(payloadBuilding?.hp ?? 0),
              maxHp: Number(payloadBuilding?.maxHp ?? 0),
            } as any
          }
        }
      }
      
      state.buildingStatus = mergedStatus
    },
    setCastle2RepairRequirements: (state: Castle2State, action: PayloadAction<{ ecsToken: number; gem: number; stone: number; wood: number }>) => {
      state.repairRequirements = action.payload
    },
    setCastle2RestoreBuilding: (state: Castle2State) => {
      state.isRestored = true
    },
    setCastle2FetchSupportCharacters: (state: Castle2State, action: PayloadAction<any[]>) => {
      state.supportCharacters = action.payload
    },
    setCastle2SupportCharacters: (state: Castle2State, action: PayloadAction<any[]>) => {
      state.supportCharacters = [...state.supportCharacters, ...action.payload]
      state.isSetSupportCharacterSuccess = true
    },
    setCastle2ClearStatus: (state: Castle2State) => {
      state.isSetSupportCharacterSuccess = false
      state.error = undefined
    },
    setCastle2SupportState: (state: Castle2State, action: PayloadAction<boolean>) => {
      state.supportState = action.payload
    },
    setCastle2UpgradeBuilding: (state: Castle2State) => {
      state.upgradeAvailable = false
    },
    setCastle2UpgradeRequirements: (state: Castle2State, action: PayloadAction<{ ecsToken: number }>) => {
      state.upgradeRequirements = action.payload
    },
    setCastle2UpgradeAvailable: (state: Castle2State, action: PayloadAction<boolean>) => {
      state.upgradeAvailable = action.payload
    },
    setCastle2RemoveCharacterFromBuilding: (state: Castle2State, action: PayloadAction<{ success: boolean; building: string; character: string }>) => {
      // Handle character removal if needed
    },
    setCastle2AddCharacterToBuilding: (state: Castle2State, action: PayloadAction<{ success: boolean; building: string; character: string }>) => {
      // Handle character addition if needed
    },
    setCastle2AllMiningStatus: (state: Castle2State, action: PayloadAction<any>) => {
      state.allMiningStatus = action.payload
    },
  },
})

export const {
  setCastle2Loading,
  setCastle2ImmediateLoading,
  setCastle2Error,
  setCastle2BuildingStatus,
  setCastle2RepairRequirements,
  setCastle2RestoreBuilding,
  setCastle2FetchSupportCharacters,
  setCastle2SupportCharacters,
  setCastle2ClearStatus,
  setCastle2SupportState,
  setCastle2UpgradeBuilding,
  setCastle2UpgradeRequirements,
  setCastle2UpgradeAvailable,
  setCastle2RemoveCharacterFromBuilding,
  setCastle2AddCharacterToBuilding,
  setCastle2AllMiningStatus,
} = castle2Slice.actions

export default castle2Slice.reducer

